import { RootState } from 'store/rootTypes';

export const BarcodeSelector = (state: RootState) => state.Barcode;
